'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('./tslib.es6-f8b34207.js');
var eventEmitter = require('./eventEmitter.js');

var instance;
var vodInstance = null;
var liveInstance = null;
var PLAYER_EVENTS = {
    USER_PLAY: 'user_play',
    AREA_CLICK: 'area_click',
    AUTOPLAY: 'autoplay',
    USER_PAUSE: 'user_pause',
    PAUSE: 'pause',
    ERROR: 'error',
    ENDED: 'ended',
    SEEKED: 'seeked',
    SEEKING: 'seeking',
    TIME_UPDATE: 'timeupdate',
    WAITING: 'waiting',
    READY: 'playerReady',
    USER_RESUME: 'user_resume',
    RESUME: 'resume',
    PLAYING: 'playing',
    LOADEDMETADATA: 'loadedMetadata',
    ORI_CAHNGE: 'orientationchange',
    FULLSCR_CHANGE: 'fullscreenchange',
    AD_EVENTS: 'adEvents',
    RESIZE: 'resize',
    PLAYING_PREV: 'playingPrev',
    PLAYING_NEXT: 'playingNext',
    SNAPSHOT_DATA: 'playerSnapshotData',
    CUT_VIDEO_DATA: 'playerCutVideoData',
    AUDIO_TRACKS_LOADED: 'audioTracksLoaded',
    AUDIO_TRACK_CHANGED: 'audioTrackChanged',
    PREVIEW_FINISHED: 'previewFinished',
    ADS_AFTER_PREROLL: 'adsAfterPreroll',
    CONCURRENCY: 'concurrency' //event ->
};
var PLAYER_METHODS = {
    MUTE: 'mute',
    PLAY: 'play',
    PAUSE: 'pause',
    CONFIGURATION: 'configuration',
    PLAY_NEW_VIDEO: 'playNow',
    SET_RESTRICTION: 'setRestrictionState',
    TOGGLE_PREVIEW: 'togglePreview',
    BUTTONS_ACT: 'actionOnButton',
    CONTROLS_STATE: 'controlsState',
    CUT_VIDEO_API: 'cutVideoApi',
    SNAPSHOT_API: 'snapshotApi',
    FORCE_LOGIN: 'force_login' //method ->
    // STOP_PREVIEW: 'previewStop',            //method ->
};
var SHOP_EVENTS = {
    PLAY_EVENT: 'play_event',
    OPEN_PRODUCT_IFRAME: 'open_product_iframe',
    CLOSE_FLOATING: 'on_floating_close',
    TOGGLE_ISO_FULL_SCREEN: 'IOSFullscreen',
    REFRESH_EVENTS: 'updateEvents',
    SWITCH_MODE: 'switchMode',
    DESTROY_EMBED: 'destroyEmbedPlayer' // when there are no more events
};
var PM = /** @class */ (function (_super) {
    tslib_es6.__extends(PM, _super);
    function PM() {
        var _this = _super.call(this) || this;
        window.addEventListener('message', _this.triggerEvent.bind(_this));
        return _this;
    }
    PM.inst = function () {
        if (!instance) {
            instance = new PM();
        }
        return instance;
    };
    PM.prototype.send = function (options) {
        var type = options.type, target = options.target || this._target, origin = options.origin || '*', sendMethod = options.sendMethod || 'default';
        if (this._target) {
            this._target = null;
        }
        if (!target) {
            return new Error('"target" window required');
        }
        if (!type) {
            return new Error('"type" is required');
        }
        var msg = {
            data: options.data,
            type: options.type
        };
        if (sendMethod === 'blob') {
            msg.sendMethod = 'blob';
        }
        try {
            if ('postMessage' in target) {
                if (sendMethod === 'blob') {
                    target.postMessage(msg, origin);
                }
                else {
                    target.postMessage(JSON.stringify(msg), origin);
                }
            }
            else if ('contentWindow' in target && 'postMessage' in target.contentWindow) {
                if (sendMethod === 'blob') {
                    target.contentWindow.postMessage(msg, origin);
                }
                else {
                    target.contentWindow.postMessage(JSON.stringify(msg), origin);
                }
            }
            return;
        }
        catch (e) {
            console.warn('catch error:', e);
            return e;
        }
    };
    PM.prototype.target = function (target) {
        if (target instanceof HTMLIFrameElement) {
            this._target = target;
        }
        else if (typeof target === 'string') {
            this._target = (document.getElementById(target) || document.querySelector("[name=\"".concat(target, "\"]")));
        }
        return this;
    };
    PM.prototype.handleTarget = function (eventName) {
        if (this._target) {
            var targetId_1 = this._target.name || this._target.id;
            if (targetId_1) {
                if (Array.isArray(eventName)) {
                    eventName = eventName.map(function (eName) {
                        return "".concat(targetId_1, ".").concat(eName);
                    });
                }
                else {
                    eventName = "".concat(targetId_1, ".").concat(eventName);
                }
            }
            this._target = null;
        }
        return eventName;
    };
    /** overwrite the base 'on' method to support subscribing by specific source */
    PM.prototype.on = function (eventName, handler, context, options) {
        eventName = this.handleTarget(eventName);
        return _super.prototype.on.call(this, eventName, handler, context, options);
    };
    /** overwrite the base 'one' method to support subscribing by specific source */
    PM.prototype.one = function (eventName, handler, context, options) {
        eventName = this.handleTarget(eventName);
        return _super.prototype.one.call(this, eventName, handler, context, options);
    };
    /** overwrite the base 'off' method to support un-subscribing by specific source */
    PM.prototype.off = function (eventName, handler) {
        if (this._target && typeof eventName === 'string') {
            var targetId = this._target.name || this._target.id;
            if (targetId) {
                eventName = "".concat(targetId, ".").concat(eventName);
            }
            this._target = null;
        }
        return _super.prototype.off.call(this, eventName, handler);
    };
    PM.prototype.triggerEvent = function (event) {
        if (!/google/i.test(event.origin)) { // reject all google data
            var msg = void 0;
            if (typeof event.data === 'object' || (event.data && event.data.sendMethod)) {
                msg = event.data;
            }
            else {
                try {
                    msg = JSON.parse(event.data);
                }
                catch (error) {
                    return;
                }
            }
            if (!msg) {
                return;
            }
            if (!msg.type) {
                // console.warn('message "type" is required');
                return;
            }
            var eventName = msg.type;
            this.emit(eventName, msg.data);
            if (event.source) {
                var frames_1 = document.getElementsByTagName('iframe');
                for (var i = 0; i < frames_1.length; i++) {
                    var frame = frames_1[i];
                    if (frame.contentWindow === event.source) {
                        var targetId = frame.name || frame.id;
                        this.emit("".concat(targetId, ".").concat(eventName), msg.data);
                        break;
                    }
                }
            }
        }
    };
    return PM;
}(eventEmitter.EventEmitter));
var PMVod = /** @class */ (function (_super) {
    tslib_es6.__extends(PMVod, _super);
    function PMVod() {
        return _super.call(this) || this;
    }
    PMVod.inst = function () {
        if (!vodInstance) {
            vodInstance = new PMVod();
        }
        return vodInstance;
    };
    return PMVod;
}(PM));
var PMLive = /** @class */ (function (_super) {
    tslib_es6.__extends(PMLive, _super);
    function PMLive() {
        return _super.call(this) || this;
    }
    PMLive.inst = function () {
        if (!liveInstance) {
            liveInstance = new PMLive();
        }
        return liveInstance;
    };
    return PMLive;
}(PM));

exports.PLAYER_EVENTS = PLAYER_EVENTS;
exports.PLAYER_METHODS = PLAYER_METHODS;
exports.PM = PM;
exports.PMLive = PMLive;
exports.PMVod = PMVod;
exports.SHOP_EVENTS = SHOP_EVENTS;
